<template>
  <nuxt-link
    :to="url"
    class="c-image-card-cta"
  >
    <nuxt-img
      v-if="backgroundImage.src"
      v-bind="$getImgOptions(backgroundImage, {
        alt: 'Image Card Cta',
      })"
      :style="{ maxWidth: '100%' }"
    />
    <div
      v-if="gradient"
      class="c-image-card-cta__gradient"
    />
    <div class="c-image-card-cta__content">
      <div>
        <p
          class="t-paragraph-large"
          :class="titleClass"
        >
          {{ title }}
        </p>
        <p class="t-paragraph">
          {{ subtitle }}
        </p>
      </div>
      <img
        src="~@/assets/icons/chevron-white.svg"
        alt="icon"
        class="c-image-card-cta__arrow-icon"
      >
    </div>
  </nuxt-link>
</template>

<script>
import { UrlFilters } from '@mixins/cdnMixins'
export default {
  mixins: [ UrlFilters ],
  props: {
    title: {
      type: String,
      default: ''
    },
    subtitle: {
      type: String,
      default: ''
    },
    url: {
      type: String,
      default: ''
    },
    gradient: {
      type: Boolean,
      default: false
    },
    backgroundImage: {
      type: Object,
      default: () => ({})
    }
  },
  computed: {
    titleClass() {
      return this.subtitle ? 'u-margin-bottom-none' : 'u-margin-bottom-xx-small'
    }
  }
}
</script>

<style lang="scss" scoped>
.c-image-card-cta {
  position: relative;
  display: inline-flex;

  &__gradient {
    position: absolute;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    background: linear-gradient(
      to bottom,
      rgba(0, 0, 0, 0),
      rgba(0, 0, 0, 0),
      rgba(0, 0, 0, 0.9)
    );
  }

  &__content {
    position: absolute;
    bottom: 0;
    left: 0;
    right: 0;
    display: flex;
    align-items: flex-end;
    justify-content: space-between;
    padding: rem(5px) rem(10px);
    color: white;
  }

  &__arrow-icon {
    width: rem(12px);
    margin-bottom: rem(12px);
  }
}
</style>
